import { render, staticRenderFns } from "./TabellaEmail.vue?vue&type=template&id=8c1d8df2&scoped=true&"
import script from "./TabellaEmail.vue?vue&type=script&lang=js&"
export * from "./TabellaEmail.vue?vue&type=script&lang=js&"
import style0 from "./TabellaEmail.vue?vue&type=style&index=0&id=8c1d8df2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1d8df2",
  null
  
)

export default component.exports